import React, { useState } from 'react'
import { CircularProgress, IconButton, Tooltip } from '@mui/material'
import GetAppIcon from '@mui/icons-material/GetApp'

import { get } from 'services/api'
import Colors from 'utils/Colors'
import { useSelector } from 'react-redux'
import Button from '@mui/material/Button'
import styles from '../styles'

const DownloadAppButton = ({
  applicationUUID,
  canDownload,
  useTitle = false,
}) => {
  const [fileLoading, setFileLoading] = useState({})

  const token = useSelector((state) => state.auth.access_token)

  const classes = styles()

  const handleFileDownload = async (id) => {
    setFileLoading({ ...fileLoading, [id]: true })

    const res = await get({
      url: `/application/report?application_uuid=${id}`,
      token,
    })

    if (res) {
      window.open(res.report_url, '_blank')
    }

    setFileLoading({ ...fileLoading, [id]: false })
  }

  const renderIconButton = () =>
    canDownload ? (
      <IconButton
        className={classes.iconButton}
        onClick={() => handleFileDownload(applicationUUID)}
        size="large"
      >
        <GetAppIcon style={{ color: Colors.primaryColor, fontSize: 20 }} />
      </IconButton>
    ) : (
      <GetAppIcon style={{ color: '#999', fontSize: 20, margin: 5 }} />
    )

  const renderLabeledButton = () => (
    <Button
      size="small"
      variant="outlined"
      disabled={!canDownload}
      onClick={() => handleFileDownload(applicationUUID)}
      startIcon={
        fileLoading[applicationUUID] ? (
          <CircularProgress size={18} color="primary" />
        ) : (
          <GetAppIcon style={{ color: Colors.primaryColor, fontSize: 20 }} />
        )
      }
    >
      Relatório
    </Button>
  )

  return !useTitle && fileLoading[applicationUUID] ? (
    <CircularProgress size={18} color="primary" />
  ) : (
    <Tooltip
      arrow
      placement="top"
      title={
        canDownload ? (
          <b className={classes.tooltipText}>Baixar o relatório da aplicação</b>
        ) : (
          <b className={classes.tooltipText}>
            O relatório estará disponível <br /> depois que o BGC for concluído
          </b>
        )
      }
    >
      {useTitle ? renderLabeledButton() : renderIconButton()}
    </Tooltip>
  )
}

export default DownloadAppButton
